export var getSanitizedError = function (errors) {
    var errorString = '';
    errors.forEach(function (element) {
        element.name = '';
        if (element.fileSizeTooSmall)
            errorString += 'File size is too small!';
        else if (element.fileSizeToolarge)
            errorString += 'File size is too large!';
        else if (element.readerError)
            errorString += 'Problem occurred while reading file!';
    });
    return errorString;
};
//# sourceMappingURL=getSanitizedError.js.map